import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { Eye, X } from "@phosphor-icons/react";

interface DocumentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  documentName: string;
  fileUrl: string;
  fileId?: string;
}

export const DocumentSuccessModal: React.FC<DocumentSuccessModalProps> = ({
  isOpen,
  onClose,
  documentName,
  fileUrl,
}) => {
  const handleViewDocument = () => {
    (window as any)?.open(fileUrl, "_blank")?.focus();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      shouldBlockScroll={true}
      isDismissable={true}
      backdrop="blur"
      className="p-4"
    >
      <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
        <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
          <div className="flex flex-col">
            <h2 className="text-xl font-semibold text-status-good">
              Document succesvol gegenereerd! 🎉
            </h2>
            <p className="text-sm text-neutral-secondary-mid mt-1">
              {documentName}
            </p>
          </div>
          <Button
            isIconOnly
            variant="light"
            onPress={onClose}
            className="text-neutral-secondary-mid hover:text-neutral-primary"
          >
            <X size={20} />
          </Button>
        </ModalHeader>

        <ModalBody className="px-0 py-4">
          <div className="flex flex-col gap-4">
            <div className="p-4 bg-brick-secondary-fine rounded-lg border border-brick-primary/20">
              <p className="text-sm text-neutral-primary mb-3">
                Je document is klaar! Je kunt het bekijken in SharePoint of direct downloaden naar je computer.
              </p>
              
              <div className="flex flex-col gap-2">
                <p className="text-xs text-neutral-secondary-mid font-medium">SharePoint Link:</p>
                <div className="p-2 bg-secondary rounded-sm text-xs text-neutral-primary break-all font-mono">
                  {fileUrl}
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button
                color="primary"
                variant="bordered"
                onPress={handleViewDocument}
                startContent={<Eye size={18} />}
                className="flex-1 sm:flex-none bg-secondary text-neutral-primary border-neutral-primary/20 hover:bg-neutral-primary hover:text-primary"
              >
                Bekijk in SharePoint
              </Button>
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="px-0 pt-2">
          <p className="text-xs text-neutral-secondary-mid text-center w-full">
            💡 Tip: Het document wordt automatisch opgeslagen in SharePoint en kan je terugvinden via je lokale mappen.
          </p>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DocumentSuccessModal;
